<!-- @file 地址列表 -->
<template>
  <div class="plv-iar-address-list">
    <div class="plv-iar-address-list-group">
      <address-card
        v-for="(item, index) in addressList"
        :key="item.id"
        :data-source="item"
        :checked="item.id === activeAddressKey"
        @delete="handleDelete(item, index)"
        @edit="$emit('edit', item, index)"
        @click="handleSelect(item)"
      />
    </div>
    <div class="plv-iar-address-list-bottom">
      <button class="plv-iar-address-list-add" @click="$emit('add')">{{ iarTrans('address.addAddressBtnText') }}</button>
    </div>
  </div>
</template>

<script>
import AddressCard from '../../components/address-list/AddressCard';
import addressList from './addressList';

export default {
  mixins: [addressList],
  components: {
    AddressCard,
  }
};
</script>

<style lang="scss">
.plv-iar-address-list {
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: 1.2;

  .plv-iar-address-list-group {
    overflow-y: scroll;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 8px 12px;
  }

  .plv-iar-address-list-bottom {
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 16px;
    background: #fff;
  }

  .plv-iar-address-list-add {
    display: block;
    width: 100%;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    color: #fff;
    border: none;
    border-radius: 40px;
    outline: none;
    user-select: none;
    touch-action: manipulation;
    background: #F15D5D;
  }
}
</style>
